import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import MembershipView from '../views/MembershipView.vue'
import PaymentView from '../views/PaymentView.vue'
import PaymentSuccessView from '../views/PaymentSuccessView.vue'
import VipStatusView from '../views/VipStatusView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/membership',
    name: 'membership',
    component: MembershipView
  },
  {
    path: '/payment/:type',
    name: 'payment',
    component: PaymentView,
    props: true
  },
  {
    path: '/payment-success',
    name: 'payment-success',
    component: PaymentSuccessView
  },
  {
    path: '/vip-status',
    name: 'vip-status',
    component: VipStatusView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
